// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1453":"20ee690fc9f74342","4238":"1fb4cbfa7e01936a","5420":"68c7b4dc178d94cb"}[chunkId] + ".css";
};